// 単位周りのヘルパークラス
export class UnitHelper
{
    // 印刷解像度
    static readonly DPI = 350.0;

    // 単位変換
    // 対応単位
    // "mm"
    // "cm"
    // "inch"
    // "pt"
    // "px"
    // "q"
    public static convert(value : number, from : string, to : string, dpi : number | null = null) : number
    {
        if(value == 0) { return 0; }

        // 使用するdpi
        var useDpi = dpi != null ? dpi : this.DPI;

        // すべてmmに換算する
        var mm = 0;
        var fromUpperCase = from.toUpperCase();
        if(fromUpperCase == "mm".toUpperCase())
        {
            mm = value;
        }
        else if(fromUpperCase == "cm".toUpperCase())
        {
            mm = value * 10;
        }
        else if(fromUpperCase == "inch".toUpperCase())
        {
            mm = value * 25.4;
        }
        else if(fromUpperCase == "pt".toUpperCase() || fromUpperCase == "point".toUpperCase())
        {
            mm = value * 25.4 / 72;
        }
        else if(fromUpperCase == "px".toUpperCase() || fromUpperCase == "pixel".toUpperCase())
        {
            mm = value * 25.4 / useDpi;
        }
        else if(fromUpperCase == "q".toUpperCase())
        {
            mm = value * 0.25;
        }

        // mmを結果に換算
        var result = 0;
        var toUpperCase = to.toUpperCase();
        if(toUpperCase == "mm".toUpperCase())
        {
            result = mm;
        }
        else if(toUpperCase == "cm".toUpperCase())
        {
            result = mm / 10;
        }
        else if(toUpperCase == "inch".toUpperCase())
        {
            result = mm / 25.4;
        }
        else if(toUpperCase == "pt".toUpperCase() || toUpperCase == "point".toUpperCase())
        {
            result = mm * 72 / 25.4;
        }
        else if(toUpperCase == "px".toUpperCase() || toUpperCase == "pixel".toUpperCase())
        {
            result = mm * useDpi / 25.4;
        }
        else if(toUpperCase == "q".toUpperCase())
        {
            result = mm / 0.25;
        }

        return result;
    }
}

/**
 * 単位をmmからpxに変換する
 * @param mm 長さ (mm)
 * @param dpi 解像度
 */
export function mm2px(mm: number, dpi: number): number {
    return UnitHelper.convert(mm, "mm", "px", dpi);
}
